// 先搜助手：英文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 助手界面
export const ui = Object.freeze({
  "pcAi.preparingAnswer": "Preparing an answer…",
  "pcAi.history": "Conversation history",
  "pcAi.newChat": "New chat",
  "pcAi.historyLoading": "Loading history...",
  "pcAi.noHistory": "No conversations yet",
  "pcAi.delete": "Delete",
  "pcAi.platformLoading": "Loading account...",
  "pcAi.signingIn": "Signing in to XSOU AI...",
  "pcAi.brand": "XSOU AI",
  "pcAi.missingIdentity": "Account identity is missing",
  "pcAi.missingIdentityHint":
    "This account has no identifier available for signing in to the AI assistant.",
  "pcAi.noModels": "No models available",
  "pcAi.reload": "Reload",
  "pcAi.welcome": "How can XSOU AI help you?",
  "pcAi.trace": "AI activity",
  "pcAi.traceFallback": "Activity",
  "pcAi.sourceCount": "{count} candidate sources",
  "pcAi.sourceHint":
    "Candidate material was provided to the model; this does not mean it was cited in the answer.",
  "pcAi.copy": "Copy message",
  "pcAi.generating": "Generating",
  "pcAi.retry": "Retry",
  "pcAi.placeholder": "How can I help you?",
  "pcAi.addAttachment": "Add attachment",
  "pcAi.uploadAttachment": "Upload an image or PDF",
  "pcAi.stop": "Stop generating",
  "pcAi.send": "Send",
  "pcAi.saving": "Saving conversation...",
  "pcAi.userLoadFailed": "Could not load account information",
  "pcAi.recommend1": "Where is Shenzhen XSOU Technology located?",
  "pcAi.recommend2": "Help me assess whether this chip can be substituted",
  "pcAi.recommend3": "How can I identify a part number's brand?",
  "pcAi.recommend4": "Suggest some commonly used domestic chip alternatives",
  "pcAi.recommend5": "How do I select electronic components by specifications?",
  "pcAi.recommend6": "Help me prepare a component purchase inquiry",
  "pcAi.recommend7":
    "Which specifications matter when selecting electronic components?",
  "pcAi.recommend8": "How do I identify and correct nonstandard part numbers?",
  "pcAi.recommend9": "Compare the main differences between two chip models",
  "pcAi.recommend10": "How can I reduce shortage risk when buying components?",
  "pcAi.recommend11":
    "How can I tell whether package variants are interchangeable?",
  "pcAi.recommend12": "Explain common chip specifications",
});

// 手机端业务流程：固定界面文案。
export const mobileWorkflow = Object.freeze({
  "mobileAi.loginContinue": "Sign in to continue using Xsou AI",
  "mobileAi.freeLimitReached":
    "You have performed several searches. Sign in to save this conversation and continue using Xsou AI.",
  "mobileAi.loginBenefits":
    "Sign in to save conversation history and access all XSOU AI features.",
});

export const speechUi = Object.freeze({
  "speechUi.voiceListFailed": "Unable to load voices",
  "speechUi.stopVoicePreview": "Stop preview",
  "speechUi.previewVoice": "Preview voice",
});

export const sharedFlowUi = Object.freeze({
  "aiFeedback.userLoadTimeout": "Loading your account timed out. Please try again.",
  "aiFeedback.searchGuestQuotaExceeded": "You have performed several searches. We recommend signing in to continue using Xsou AI.",
  "aiFeedback.searchGuestLoading": "Searching…",
  "aiFeedback.searchGuestFailed": "Xsou AI is temporarily unavailable. Please try again later.",

  "aiFeedback.renameFailed": "Unable to rename the conversation",
  "aiFeedback.clearTemporaryChat": "Clear temporary conversation",
  "aiFeedback.guest": "Guest",
  "aiFeedback.clearTemporaryChatHint":
    "Cleared guest conversations cannot be restored. Your remaining questions will not reset",
  "aiFeedback.deleteConversationConfirm": "Delete “{name}”?",
});

export const messages = Object.freeze({
  ...sharedFlowUi,
  ...speechUi,
  ...mobileWorkflow,
  ...ui,
});
